import { render, staticRenderFns } from "./SaveResponseCategoryAddModal.vue?vue&type=template&id=8611a020"
import script from "./SaveResponseCategoryAddModal.vue?vue&type=script&lang=js"
export * from "./SaveResponseCategoryAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports